import { render, staticRenderFns } from "./SwapPopup.vue?vue&type=template&id=f8d3a306&scoped=true"
import script from "./SwapPopup.vue?vue&type=script&lang=js"
export * from "./SwapPopup.vue?vue&type=script&lang=js"
import style0 from "./SwapPopup.vue?vue&type=style&index=0&id=f8d3a306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d3a306",
  null
  
)

export default component.exports